"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TabNav_1 = require("./TabNav");
exports.TabNav = TabNav_1.default;
//# sourceMappingURL=index.js.map